import { useCallback, useEffect, useState } from 'react';
import { fetchUnreadNotices, markNoticeRead } from '../api/siteNotices';

/**
 * Плашки ручных объявлений: непрочитанные скрываются по «Понятно».
 */
export default function SiteNoticesBanner() {
  const [notices, setNotices] = useState([]);
  const [markingId, setMarkingId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchUnreadNotices()
      .then((items) => {
        if (!cancelled) setNotices(items);
      })
      .catch(() => {
        if (!cancelled) setNotices([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const handleRead = useCallback(async (noticeId) => {
    setMarkingId(noticeId);
    try {
      await markNoticeRead(noticeId);
      setNotices((prev) => prev.filter((n) => n.id !== noticeId));
    } catch {
      // оставляем плашку, если запрос не прошёл
    } finally {
      setMarkingId(null);
    }
  }, []);

  if (!notices.length) return null;

  return (
    <div className="site-notices-stack" role="region" aria-label="Объявления">
      {notices.map((notice) => (
        <div key={notice.id} className="alert alert-warning site-notice-banner" role="status">
          <div className="site-notice-banner__body">
            {notice.title ? <strong className="site-notice-banner__title">{notice.title}</strong> : null}
            {notice.body ? (
              <p className="site-notice-banner__text">{notice.body}</p>
            ) : null}
          </div>
          <button
            type="button"
            className="btn btn-sm btn-primary site-notice-banner__btn"
            disabled={markingId === notice.id}
            onClick={() => handleRead(notice.id)}
          >
            Понятно
          </button>
        </div>
      ))}
    </div>
  );
}
